import { useAtomValue, useSetAtom } from 'jotai';

import { FloatingDraggable } from '@/components/floating-draggable/floating-draggable';
import { openToItemAtom } from '@/features/developer-tools/state/dev-tools-panel.state';
import { Button } from '@/ux-common/components/button/button';

import {
  hasUxdsVersionRollbackAtom,
  uxdsVersionRollbackStorageAtom,
} from './uxds-version-rollback.state';
import {
  UXDS_VERSION_ROLLBACK_CONFIG,
  UXDS_VERSION_ROLLBACK_NAMESPACES,
  type UxdsRollbackNamespace,
} from './uxds-version-rollback-namespaces';

const buildPreviewLabel = (versions: Partial<Record<UxdsRollbackNamespace, number>>): string => {
  const labels = UXDS_VERSION_ROLLBACK_NAMESPACES.filter((ns) => versions[ns] != null).map(
    (ns) => `${UXDS_VERSION_ROLLBACK_CONFIG[ns].shortLabel} v${versions[ns]}`
  );
  return `Previewing ${labels.join(', ')}`;
};

export const UxdsVersionRollbackButton = () => {
  const storage = useAtomValue(uxdsVersionRollbackStorageAtom);
  const hasAnyVersion = useAtomValue(hasUxdsVersionRollbackAtom);
  const openToItem = useSetAtom(openToItemAtom);

  if (!hasAnyVersion) {
    return null;
  }

  const versions = storage?.versions ?? {};

  return (
    <FloatingDraggable
      storageKey="uxds-version-rollback-button-position"
      defaultPosition={{
        right: 90,
        bottom: 70,
      }}
    >
      <Button
        className="btn btn-default btn-sm shadow-lg hover:shadow-xl ring-2 ring-[#7B68EE] hover:ring-[#7B68EE]/20 transition-all duration-200 hover:scale-105"
        style={{ backgroundColor: '#7B68EE' }}
        onClick={() => {
          openToItem('uxds-version-rollback');
        }}
        aria-label="Open UXDS version rollback"
        data-component="UxdsVersionRollbackButton"
        data-testid="uxds-version-rollback-button"
      >
        <span className="text-white font-semibold text-xs whitespace-nowrap">
          {buildPreviewLabel(versions)}
        </span>
      </Button>
    </FloatingDraggable>
  );
};
